import { render } from "./RecentSearchWordComponent.vue?vue&type=template&id=44a41c2e&scoped=true&ts=true"
import script from "./RecentSearchWordComponent.vue?vue&type=script&lang=ts"
export * from "./RecentSearchWordComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/TCD-GIFTSHOP-CHANNELING-FRONT/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44a41c2e"]])

export default __exports__